import { Injectable } from '@angular/core';
import { PermissionCheckerService } from 'abp-ng2-module';
import { AppSessionService } from '../session/app-session.service';
import { PermissionNames } from '@shared/PermissionNames';

import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild
} from '@angular/router';
import { AppConsts } from '../AppConsts';

@Injectable()
export class AppRouteGuard implements CanActivate, CanActivateChild {

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
    ) { }


    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

        var parts = window.location.href.split('/');
        if (parts && parts.length) {
            if (parts[2] === 'soft-area.ro') {
                window.location.href = AppConsts.appBaseUrl;
                return;
            }
        }

        if (!this._sessionService.user) {
            this._router.navigate(['/account/login']);
            return false;
        }

        if (!route.data || (!route.data['permission'] && (!route.data['permissionNames'] || !route.data['permissionNames'].length))) {
            return true;
        }
        if (route.data['permission']) {
            return this._permissionChecker.isGranted(route.data['permission']);
        }
        if (route.data['permissionNames'] && route.data['permissionNames'].length) {
            var grantedPermissions = 0;
            for (var i = 0; i < route.data['permissionNames'].length; i++) {
                if (this._permissionChecker.isGranted(route.data['permissionNames'][i])) {
                    if (!route.data['requireAllPermissions'])
                        return true;
                    grantedPermissions++;
                }
            }
            if (route.data['requireAllPermissions'] && grantedPermissions == route.data['permissionNames'].length) {
                return true;
            }
        }

        this._router.navigate([this.selectBestRoute()]);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    selectBestRoute(): string {
        if (!this._sessionService.user) {
            return '/account/login';
        }

        if (this._permissionChecker.isGranted(PermissionNames.Pages_Scanning)) {
            return '/app/scanning';
        }

        if (this._permissionChecker.isGranted(PermissionNames.Pages_Maintenance)) {
            return '/app/maintenance';
        }

        if (this._permissionChecker.isGranted(PermissionNames.Pages_Repair)) {
            return '/app/repair';
        }

        if (this._permissionChecker.isGranted(PermissionNames.Pages_Tenants)) {
            return '/app/tenants';
        }

        if (this._permissionChecker.isGranted(PermissionNames.Pages_Users)) {
            return '/app/users';
        }

        return '/app/about';
    }
}
